// extracted by css-extract-rspack-plugin
export default {"container":"container-RnCwcM","aside":"aside-jR_OB_","main":"main-ZOqbkf"};